import React from "react";
import "./terms_of_service.css";
import Footer from "../../component/footer/Footer";

const TermsOfService = () => {
  return (
    <div className="service-main">
      <div className="service-container">
        <h1>Terms of Service</h1>
        <div className="service-content">
          <div className="service-details">
            <h2>TERMS AND CONDITIONS FOR PICKLOAD PARCEL</h2>
            <p>
              By accepting the following terms and conditions for PICKLOAD
              PARCEL, you (THE CUSTOMER) are agreeing to all the following terms
              and conditions without exception. The Terms of Use stated herein
              (collectively, the “Terms of Use” or this “Agreement”) constitute
              a legal agreement between you, the Rider/Driver/Fleet Manager and
              PICKLOAD (the “Company”). In order to use the Service defined
              below, you must agree to the Terms of Use that are set out in the
              following. The Company reserves the right to modify, vary and
              change the Terms of Use or its policies relating to the Service at
              any time as it deems fit. Such modifications, variations and or
              changes to the Terms of Use or its policies relating to the
              Service shall be effective upon the posting of an updated version
              at PICKLOAD. You agree that it shall be your responsibility to
              review the Terms of Use regularly whereupon the continued use of
              the Service after any such changes, whether or not reviewed by
              you, shall constitute your consent and acceptance to such changes.
            </p>
          </div>
          <div className="service-details">
            <h2>Terms and Conditions</h2>
            <p>
              In these Terms and Conditions where the following terminology has
              been used, they shall have the following meanings
            </p>
            <p>
              Consignment: Will mean any item(s) of any sort which are or are
              intended to be, received by us from any one sender at an address
              for us to carry and deliver to any recipient at any other address.
            </p>
            <p>
              Aged Consignment: Will mean a Consignment that is no longer in the
              condition in which it was received by us, or which is or becomes a
              health and safety risk.
            </p>
            <p>
              Out of Gauge: Will mean a Consignment is outside of the weight and
              dimensions that we carry on a particular service.
            </p>
            <p>
              Prohibited Items: Will mean that it cannot be carried on any
              Service and are contrabands under the laws of the land.
            </p>
            <p>
              The Collection Point: Will mean the address at which a Consignment
              is received or collected by us.
            </p>
            <p>
              The Delivery Point: Will mean the address to which any Consignment
              is delivered by us.
            </p>
            <p>
              Service: Will mean the service and carriage of a Consignment by
              Rider/Driver in accordance with the particulars set out in the
              Service Order, as per the terms and conditions.
            </p>
          </div>
          <div className="service-details">
            <h2>Service</h2>
            <p>
              The Service(s) will be carried out for you whilst this Agreement
              is in force, in return for the payment by you to us of the price
              set out in the Service Order and in accordance with the terms of
              this Agreement. PICKLOAD Parcel shall have the right to make any
              changes to the Service(s) which are necessary to comply with any
              applicable law or safety requirement or which do not materially
              affect the nature or quality of the Service(s) and any changes are
              not liable to be notified to you.
            </p>
          </div>
          <div className="service-details">
            <h2>Loading and Unloading</h2>
            <p>
              If collection or delivery of a Consignment takes place at your
              premises, PICKLOAD Parcel shall not be under any obligation to
              provide any equipment or labour which, apart from the Rider/Driver
              collecting the Consignment, may be required for loading or
              unloading of a Consignment.
            </p>
            <p>
              Any Consignment (or part of a Consignment) requiring any special
              equipment for loading and unloading shall be accepted by us for
              transportation only on the understanding and condition that such
              special equipment will be made available at the Collection Point
              and the Delivery Point as required. Where such equipment is not
              available and if the Rider/Driver agrees to load or unload the
              Consignment (or part of the Consignment) PickLoad shall be under
              no liability or obligation of any kind to you for any damage
              caused (however it may be caused) during the loading or unloading
              of the Consignment.
            </p>
            <p>
              This includes any damage caused whether or not by the Rider/Driver
              negligence and you shall agree to indemnify and hold us harmless
              against any claim or demand from any person arising out of this
              agreement to load or unload the Consignment in these
              circumstances.
            </p>
          </div>
          <div className="service-details">
            <h2>Collection and Deliveries</h2>
            <p>
              The Rider/Driver/Fleet Manager will make one attempt to deliver a
              Consignment during normal working hours. If the Rider/Driver/Fleet
              Manager cannot obtain a delivery receipt at the Delivery Point you
              agree that the Rider/Freelancer shall be authorised to attempt to:
              deliver the Consignment to, or obtain a delivery receipt from, an
              alternative address close to the Delivery Point; or deliver the
              Consignment to a safe location at the Delivery Point and (if
              successful) the Rider/Driver/Fleet Manager agrees that he/she will
              leave at the Delivery Point details of the address or safe
              location to which he/she have delivered the Consignment.
            </p>
            <p>
              If the Rider/Driver/Fleet Manager is unable to deliver to the
              Delivery Point, a nearby address or a safe location, the
              Rider/Driver/Fleet Manager shall return the Consignment to a
              designated location and leave a request for the recipient of the
              Consignment to contact the Rider/Driver/Fleet Manager to make
              alternative delivery arrangements to the Delivery Point. If the
              recipient does not contact you to arrange the alternative delivery
              within 24 hours, the Rider/Driver/Fleet Manager is to return the
              item to PickLoad office with all necessary details of the
              consignment.
            </p>
            <p>
              If the Rider/Driver/Fleet Manager considers that the Consignment
              has become a Damaged Consignment and cannot be delivered because
              it is or in his/her reasonable opinion is likely to be unsafe
              hazardous or harmful after left for a period of time 24 Hours
              plus. They Rider/Driver/Fleet Manager shall report with the
              consignment to PICKLOAD Office for inspection and further
              necessary action.
            </p>
          </div>
          <div className="service-details">
            <h2>Terms of Use of the Service</h2>
            <p>Your Obligations You agree to:</p>
            <p>
              i. Ensure that the information you supply in the Order Schedule is
              complete and accurate; co-operate with the Rider and freelancer
              and PickLoad in all matters relating to the provision of the
              Service(s);
            </p>
            <p>
              ii. Provide PickLoad with such information and materials as may be
              reasonably required in order to supply the Service(s) and ensure
              that such information is accurate in all material respects.
            </p>
            <p>
              iii. You agree that shall not accept, and that you shall be cause
              by any Client to carry anything if it would be illegal or unlawful
              under the laws of the Federal Republic of Nigeria. You agree that
              should you do this, you will indemnify PickLoad against any losses
              and/or damage that we may suffer as a consequence.
            </p>
            <p>
              iv. The Rider/Driver/Fleet Manager shall not, carry: livestock;
              Food Items; liquids; perishable goods; gasses; pyrotechnics; arms;
              ammunition; corrosive; toxic; flammable; explosive; oxidising or
              radioactive materials. In addition, the Rider/Driver/Fleet Manager
              will not carry any items which are prohibited by the laws of the
              Land. The Rider/Driver/Fleet Manager and PickLoad reserves the
              right to refuse to carry any items which are neither the property
              of, nor sent on behalf of, you.
            </p>
            <p>It is understood that you agree that:</p>
            <p>
              All Consignments shall be accepted at the Receiving Point and
              Deliver to the Delivery point as soon as possible within same day
              period in same condition as received from Client.
            </p>
            <p>
              You are barred from receiving contrabands as specified by the laws
              of the Land. You are liable to ensure the disclose of all
              necessary information regarding the product you are receiving from
              Clients. You will not be allowed to receive any food items. You
              are not allowed to receive passport, bank cheques or any material
              pertaining to a cash transaction between two entities.
            </p>
            <p>
              You are to maintain the orders according to the outlined product
              categories, fully understanding each category description and
              strictly abiding by any restrictions a product category imposes on
              the user.
            </p>
            <p>
              You are to maintain extreme caution while packing the product, so
              as to diminish chances of damage as much as possible. You are to
              make sure that the items are properly packed to avoid injury or
              accident transportation.
            </p>
            <p>
              You are to encourage bubble-wrap of any electronics you to receive
              form Clients, so as to avoid damaging the item.
            </p>
            <p>
              All payment are made by Client via the PickLoad App payment
              method, however you are not requested to collect any money from
              the Client. You are to report any damaged/missing/lost items to
              our support team within 5 hours of dispatch. PickLoad would not
              take liability of any item that is damaged or lost.
            </p>
          </div>
          <div className="service-details">
            <h2>Liability</h2>
            <p>
              YOUR ATTENTION IS DRAWN PARTICULARLY TO THIS CLAUSE AND THE LIMITS
              OF OUR LIABILITY WITHIN IT. As a responsible business, PickLoad
              and the respective Riders/Freelancers shall hopefully perform the
              Service(s) in a professional manner with the appropriate level of
              skill and care. PickLoad will not take liability of any item that
              is damaged or lost. Damage to a Consignment may still occur as a
              consequence of handling of it and in such circumstances, PickLoad
              liability shall be limited as set out in this Terms and
              Conditions.
            </p>
            <p>
              The reasoning behind this limitation of our liability is as
              follows: The value of a Consignment and the amount of potential
              loss to you that could arise if a Consignment is damaged or lost
              is not something which can be easily ascertained but is something
              which is better known to the Client.
            </p>
            <p>
              In many cases it cannot be known to PickLoad at all and can only
              be known to the Client. The potential amount of loss that might be
              caused or alleged to be caused to you is likely to be
              disproportionate to the sum that could reasonably be expected to
              charge you for providing the Service(s) under this Agreement.
            </p>
            <p>
              It is not possible to obtain cover which would give unlimited
              compensation for full potential liability to all customers and,
              even if it were, such cover would be much cheaper if taken out by
              you and on that basis, it is more reasonable for you to take out
              such cover from an independent third party. It is imperative to
              keep the costs of providing the Service(s) to you as low as
              possible.
            </p>
            <p>
              In this Terms and Conditions, damage to you means any loss of, or
              damage to, a Consignment.
            </p>
            <p>
              PICKLOAD shall not be liable to you under any circumstances where
              there are any material discrepancies between the declared
              dimensions and weights and the actual dimensions and weights;
            </p>
          </div>
          <div className="service-details">
            <h2>Payment</h2>
            <p>
              Payment shall be made every Sunday of the week for all deliveries
              carried out in previous week ( Payment of Deliveries from Sunday
              to Saturday). All payment shall be made via your bank account.
            </p>
            <p>
              Selecting a particular payment method for the weekly remittance
              means you are agreeing to the terms of service of the Company's
              processing partners and your financial institution. You will bear
              all fees that may be charged by such processing partners and/or
              your financial institution (if any) for the payment method you
              have selected.
            </p>
          </div>
          <div className="service-details">
            <h2>Taxes</h2>
            <p>
              You agree that this Agreement shall be subject to all prevailing
              statutory taxes, duties, fees, charges and/or costs, however
              denominated, as may be in force in Nigeria and in connection with
              any future taxes that may be introduced at any point of time. You
              further agree to use your best efforts to do everything necessary
              and required by the relevant laws to enable, assist and/or defend
              the Company to claim or verify any input tax credit, set off,
              rebate or refund in respect of any taxes paid or payable in
              connection with the Service supplied under this Agreement.
            </p>
          </div>
          <div className="service-details">
            <h2>License Grant & Restrictions</h2>
            <p>
              The Company and its licensors, where applicable, hereby grants you
              a revocable, non-exclusive, non-transferable, non-assignable,
              personal, limited license to use the Application and/or the
              Software, solely for your own personal, non-commercial purposes,
              subject to the Terms of Use herein. All rights not expressly
              granted to you are reserved by the Company and its licensors.
            </p>
            <p>
              (a) You shall not license, sublicense, sell, resell, transfer,
              assign, distribute or otherwise commercially exploit or make
              available to any third party the Application and/or the Software
              in any way; modify or make derivative works based on the
              Application and/or the Software; create internet “links” to the
              Application or “frame” or “mirror” the Software on any other
              server or wireless or internet-based device; reverse engineer or
              access the Software in order to;
            </p>
            <p>i. Build a competitive product or service;</p>
            <p>
              ii. Build a product using similar ideas, features, functions or
              graphics of the Application and/or the Software, or ;
            </p>
            <p>
              iii. Copy any ideas, features, functions or graphics of the
              Application and/or the Software, launch an automated program or
              script, including, but not limited to, web spiders, web crawlers,
              web robots, web ants, web indexers, bots, viruses or worms, or any
              program which may make multiple server requests per second, or
              unduly burdens or hinders the operation and/or performance of the
              Application and/or the Software, use any robot, spider, site
              search/retrieval application, or other manual or automatic device
              or process to retrieve, index, “data mine”, or in any way
              reproduce or circumvent the navigational structure or presentation
              of the Service or its contents; post, distribute or reproduce in
              any way any copyrighted material, trademarks, or other proprietary
              information without obtaining the prior consent of the owner of
              such proprietary rights, remove any copyright, trademark or other
              proprietary rights notices contained in the Service.
            </p>
            <p>
              (b) You may use the Software and/or the Application only for your
              personal, non-commercial purposes and shall not use the Software
              and/or the Application to: send spam or otherwise duplicative or
              unsolicited messages; send or store infringing, obscene,
              threatening, libellous, or otherwise unlawful or tortious
              material, including but not limited to materials harmful to
              children or violative of third party privacy rights; send material
              containing software viruses, worms, trojan horses or other harmful
              computer code, files, scripts, agents or programs; interfere with
              or disrupt the integrity or performance of the Software and/or the
              Application or the data contained therein; attempt to gain
              unauthorized access to the Software and/or the Application or its
              related systems or networks; or Impersonate any person or entity
              or otherwise misrepresent your affiliation with a person or entity
              to abstain from any conduct that could possibly damage the
              Company's reputation or amount to being disreputable.
            </p>
          </div>
          <div className="service-details">
            <h2>Intellectual Property Ownership</h2>
            <p>
              The Company and its licensors, where applicable, shall own all
              right, title and interest, including all related intellectual
              property rights, in and to the Software and/or the Application and
              by extension, the Service and any suggestions, ideas, enhancement
              requests, feedback, recommendations or other information provided
              by you or any other party relating to the Service.
            </p>
            <p>
              For the avoidance of doubt, the term the Software and the
              Application herein shall include its respective components,
              processes and design in its entirety.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;
